import './billing-details-content-row.scss';

interface IProps {
    children: React.ReactNode[];
    className?: string;
}

const BillingDetailsContentRow: React.FC<IProps> = ({ children, className = '' }) => {
    return (
        <div className={`billing-details-content-row ${className}`}>
            {children}
        </div>
    );
}

export default BillingDetailsContentRow;
